import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeneralFilter } from '@app/shared';
import { ScreenService } from '@app/core';
import { AdministrationUtilsService } from '../../features/administration/services/administration-utils.service';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-layout-main',
  standalone: false,

  templateUrl: './layout-main.component.html',
  styleUrl: './layout-main.component.less',
})
export class LayoutMainComponent implements OnInit {
  @Input() title: string = '';
  @Input() icon: string = '';
  @Input() color: string = '';
  @Input() bgColor: string = '';
  @Input() adjustPaddingBot: boolean = false;
  @Input() filters: GeneralFilter[] = []; // Filtros generales
  @Input() primaryBtnLabel: string = '';
  @Input() secondaryBtnLabel: string = '';
  @Input() showSecondaryBtn: boolean = false;
  @Input() showSearchBar: boolean = true;
  @Input() isNotification: boolean = false;
  @Input() showMobileSearchBar: boolean = true;
  @Input() fullWidth: boolean = false;
  @Input() hideFilters: boolean = false;
  @Input() showGlobalSearchBar: boolean = true;
  @Input() mobileSearchClass?: string;
  @Output() filterEvent = new EventEmitter<{
    code: string;
    searchValue: string;
  }>();
  @Output() primaryBtnEvent = new EventEmitter<void>();
  @Output() secondaryBtnEvent = new EventEmitter<void>();

  isMobile$;
  hideSearch = true;
  searchValue = '';
  hideGlobalSearch: boolean = true;

  isAdministrationView: boolean = false;

  constructor(
    private screenService: ScreenService,
    public administrationUtilsService: AdministrationUtilsService,
    private authService: AuthService
  ) {
    this.isMobile$ = screenService.isMobile$;
  }

  ngOnInit() {
    this.isAdministrationView =
      window.location.href.includes('/administration');

    // Configurar mobileSearchClass basado en la ruta actual
    this.configureMobileSearchClass();

    if (this.authService.loggedUser$.value?.roleId === 3) {
      this.administrationUtilsService.administrationView$.next(
        'Ver estados de pago'
      );
    }
  }

  private configureMobileSearchClass() {
    // Si no hay valor personalizado, configurar basado en la ruta
    if (!this.mobileSearchClass) {
      // Si la URL contiene '/projects' sin '/detail/', es la página principal de proyectos
      if (
        window.location.href.includes('/projects') &&
        !window.location.href.includes('/detail/')
      ) {
        this.mobileSearchClass = 'mobile-search-filter-project';
      } else {
        this.mobileSearchClass = 'mobile-search-filter';
      }
    }
  }

  // Quizas la logica de filtrado sea mejor en un servicio
  onFilterSelect(filter: GeneralFilter) {
    this.filters.forEach((f) => (f.active = false));
    filter.active = true;
    this.filterEvent.emit({
      code: filter.code || '',
      searchValue: this.searchValue,
    });
  }

  toggleSearch(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.hideGlobalSearch = true;
    this.hideSearch = !this.hideSearch;
  }

  toggleGlobalSearch(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.hideSearch = true;
    this.hideGlobalSearch = !this.hideGlobalSearch;
  }

  emitPrimaryBtnEvent(): void {
    this.primaryBtnEvent.emit();
  }

  emitSecondaryBtnEvent(): void {
    this.secondaryBtnEvent.emit();
  }

  emitSearch(): void {
    const activeFilter = this.filters.find((f) => f.active);

    this.filterEvent.emit({
      code: activeFilter?.code || '',
      searchValue: this.searchValue,
    });
  }

  cleanSearch(): void {
    this.searchValue = '';
    this.emitSearch();
  }

  handleSegmentedValueChange(value: any) {
    this.administrationUtilsService.administrationView$.next(value);
  }
}
